import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItineraryComponent } from './itinerary.component';
import { TagTextModule } from '../tag-text/tag-text.module';
import { OffersModule } from '../offers/offers.module';
import {SafeHtmlModule} from "../../pipes/safe-html/safe-html.module";
import { TranslateModule } from '@ngx-translate/core';
import { EvaButtonModule } from '../eva-button/eva-button.module';

@NgModule({
    declarations: [
        ItineraryComponent
    ],
    imports: [
        CommonModule,
        TagTextModule,
        OffersModule,
        SafeHtmlModule,
        TranslateModule,
        EvaButtonModule
    ],
    exports: [
        ItineraryComponent
    ]
})
export class ItineraryModule {}
